import PropTypes from 'prop-types';

/**
 * Reusable Pagination component
 * Uses Bootstrap classes for consistent styling
 */
export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  showFirstLast = true,
  showPageInfo = true,
  maxVisible = 5,
  className = '',
}) {
  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + 4);
    start = Math.max(1, end - 4);

    for (let i = start; i <= end && i <= totalPages; i++) {
      pages.push(i);
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className={`pagination ${className}`.trim()}>
      {showFirstLast && (
        <button
          className="btn btn-sm btn-secondary"
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          aria-label="First page"
        >
          &#171;
        </button>
      )}
      <button
        className="btn btn-sm btn-secondary"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label="Previous page"
      >
        Prev
      </button>
      {pageNumbers.map((pageNum) => (
        <button
          key={pageNum}
          className={`btn btn-sm ${pageNum === currentPage ? 'btn-success' : 'btn-light'}`}
          onClick={() => onPageChange(pageNum)}
          aria-current={pageNum === currentPage ? 'page' : undefined}
          aria-label={`Page ${pageNum}`}
        >
          {pageNum}
        </button>
      ))}
      <button
        className="btn btn-sm btn-secondary"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
        aria-label="Next page"
      >
        Next
      </button>
      {showFirstLast && (
        <button
          className="btn btn-sm btn-secondary"
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage >= totalPages}
          aria-label="Last page"
        >
          &#187;
        </button>
      )}
      {showPageInfo && (
        <span className="page-info">
          Page {currentPage} of {totalPages}
        </span>
      )}
    </div>
  );
}

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  showFirstLast: PropTypes.bool,
  showPageInfo: PropTypes.bool,
  maxVisible: PropTypes.number,
  className: PropTypes.string,
};

